"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const ui_1 = require("@completeanatomy/ui");
const OptionsButton_1 = __importDefault(require("../../atoms/OptionsButton"));
const Tooltip_1 = require("../../atoms/Tooltip");
const PainSettingsPopup_1 = __importDefault(require("../PainSettingsPopup"));
const TooltipWithModal_1 = __importDefault(require("../../atoms/TooltipWithModal"));
const usePainOptions_1 = require("../../hooks/usePainOptions");
const providers_1 = require("../../providers");
function ToolsPainOptionsPanel({ className }) {
    const [isSettingsOpen, toggleSettings] = (0, ui_1.useToggleState)(false);
    const buttonRef = (0, react_1.useRef)();
    const tools = (0, providers_1.useToolsService)();
    const painManager = tools === null || tools === void 0 ? void 0 : tools.getThreeDToolManager();
    const { isPulsating: currentIsPulsating, type: currentType } = (0, usePainOptions_1.usePainOptions)();
    const [toolType, setToolType] = (0, react_1.useState)(currentType);
    const [isPulsating, setIsPulsating] = (0, react_1.useState)(currentIsPulsating);
    const handleSelectType = (type) => {
        painManager === null || painManager === void 0 ? void 0 : painManager.updatePainOptions({
            isPulsating: currentIsPulsating,
            type: type,
        });
        setToolType(type);
    };
    const handleChangePulsating = (checked) => {
        painManager === null || painManager === void 0 ? void 0 : painManager.updatePainOptions({
            isPulsating: checked,
            type: currentType,
        });
        setIsPulsating(checked);
    };
    return ((0, jsx_runtime_1.jsxs)(Container, { className: className, role: "dialog", "data-e2e": 'ToolsPainOptionsPanel_Container', children: [(0, jsx_runtime_1.jsx)(SettingsButton, { forwardedRef: buttonRef, onClick: toggleSettings, "data-e2e": 'ToolsPainOptionsPanel_SettingsButton', children: (0, jsx_runtime_1.jsx)(ButtonIcon, { name: ui_1.Icons.Settings, "data-e2e": 'ToolsPainOptionsPanel_ButtonIcon' }) }), (0, jsx_runtime_1.jsx)(SettingsTooltip, { position: Tooltip_1.TooltipPosition.Top, padding: { width: 0, height: 0 }, isOpen: isSettingsOpen, onToggle: toggleSettings, targetElement: buttonRef.current, "data-e2e": 'ToolsPainOptionsPanel_SettingsTooltip', children: (0, jsx_runtime_1.jsx)(PainSettingsPopup_1.default, { type: toolType, isPulsating: isPulsating, onSelectType: handleSelectType, onChangePulsating: handleChangePulsating, "data-e2e": 'ToolsPainOptionsPanel_ToolsPainSettingsPopup' }) })] }));
}
exports.default = ToolsPainOptionsPanel;
const Container = styled_components_1.default.div `
  position: relative;

  display: flex;
`;
const SettingsButton = (0, styled_components_1.default)(OptionsButton_1.default) `
  margin: 0;
`;
const ButtonIcon = (0, styled_components_1.default)(ui_1.Icon) `
  width: 35px;
  height: 35px;
`;
const SettingsTooltip = (0, styled_components_1.default)(TooltipWithModal_1.default) `
  border-radius: 8px;
`;
